import { action } from 'typesafe-actions';
import ActionTypes from './actionTypes';
import { AlumnoFilter, RequestStatus } from './types';

// Pantalla de Photos
// export const getPhotosRequest = () =>  action(ActionTypes.GET_PHOTOS_REQUEST);
export const getPhotos = (payload) => action(ActionTypes.GET_PHOTOS, payload);
export const setPhotos = (payload) => action(ActionTypes.SET_PHOTOS, payload);

export const getPhotosCount = (payload) =>
  action(ActionTypes.GET_PHOTOS_COUNT, payload);
export const setPhotosCount = (payload) =>
  action(ActionTypes.SET_PHOTOS_COUNT, payload);

export const getExcelPhotos = (payload) =>
  action(ActionTypes.GET_EXCEL_PHOTOS, payload);

export const getFilterAlumnoValidationRequest = () =>
  action(ActionTypes.GET_ALUMNS_VALIDATIONPHOTOS_REQUEST);

export const setFilterAlumnoValidation = (payload: AlumnoFilter[]) =>
  action(ActionTypes.SET_ALUMNS_VALIDATIONPHOTOS, payload);

export const setGetAlumnsValidationPhotosRequestStatus = (
  payload: RequestStatus
) =>
  action(ActionTypes.SET_GET_ALUMNS_VALIDATIONPHOTOS_REQUEST_STATUS, payload);

export const removePhotosFilter = () =>
  action(ActionTypes.REMOVE_PHOTOS_FILTER);

export const postValidRequest = (payload) =>
  action(ActionTypes.POST_PHOTO_VALID_SELECTION, payload);
export const postRejectRequest = (payload) =>
  action(ActionTypes.POST_PHOTO_REJECT_SELECTION, payload);

export const setPostRejectPhotoRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_PHOTO_REJECT_REQUEST_STATUS, payload);

export const setPostValidPhotoRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_PHOTO_VALID_REQUEST_STATUS, payload);
